module.exports = __webpack_public_path__ + "static/media/1024666.9b352055.png";